export default {
  SET_AUDIT_ENTRIES(state, auditEntries) {
    state.auditEntries = auditEntries;
  },

  SET_VIEWING_AUDIT(state, viewingAudit) {
    state.viewingAudit = viewingAudit;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PAGE(state, page) {
    state.page = page;
  },

  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },

  SET_ORDER_BY(state, orderBy) {
    state.orderBy = orderBy;
  },

  SET_SEARCH(state, search) {
    state.search = search;
  },
};
